import { generateClient, GraphQLResult } from "aws-amplify/api";
import { getFormInstance } from "../graphql/queries";
import getTableFields from "./getTableFields";
import { recordSentry } from "./recordSentry";
import { FieldInstance, FormInstance } from "db/definitions";

/**
 * Gets all field instances that belong to a specific FormInstance
 * @param {Id} id for the form template by which to retrieve the field templates.
 * @returns all the field templates.
 */
async function getFullFormInstanceForPhotolog(id: string, online: boolean) {
	let formInstance = (await getBatch(id, [])) as FormInstance;

	// loop through and find the imageroll fields and make sure those are all there
	for (let i = 0; i < formInstance.fieldInstances.items.length; i++) {
		const fieldInstance = formInstance.fieldInstances.items[i];
		if (fieldInstance.fieldTemplate?.inputType === "imageroll" || fieldInstance.fieldTemplate?.inputType === "table") {
			// there is some pagination required
			const tableFields = await getTableFields(fieldInstance.id, online);
			formInstance.fieldInstances.items[i].tableFields.items = tableFields;
		}
	}
	return formInstance;
}

async function getBatch(formInstanceId: string, prevItems: FieldInstance[], nextToken?: string): Promise<FormInstance | FieldInstance[]> {
	try {
		interface QueryResponse {
			getFormInstance: FormInstance;
		}
		const client = generateClient({ authMode: "userPool" });
		const result = (await client.graphql({
			query: getFormInstance,
			variables: {
				nextToken: nextToken,
				id: formInstanceId,
			},
			authMode: "userPool",
		})) as unknown as GraphQLResult<QueryResponse>;
		const formInstance = result.data.getFormInstance;
		if (formInstance.fieldInstances.nextToken) {
			prevItems = prevItems.concat(formInstance.fieldInstances.items);
			return getBatch(formInstance.id, prevItems, formInstance.fieldInstances.nextToken);
		} else {
			prevItems = prevItems.concat(formInstance.fieldInstances.items);
			formInstance.fieldInstances.items = prevItems;
			return formInstance;
		}
	} catch (error) {
		recordSentry({ error, msg: "Error getting full form instance: " });
	}
	return prevItems;
}

export default getFullFormInstanceForPhotolog;
